var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { getFormData, isValidField } from "../../Utils";
import { FORM_DATA, FORM_DATA_ARRAY } from "../../globals";
import { getLocalStoragePrefs, setLocalStoragePrefs } from "../../Storage";
import FormComponent from "../FormComponent";
var CollectFormData = function (_a) {
    var _b;
    var execution = _a.execution, executeNodeOnUserInteraction = _a.executeNodeOnUserInteraction;
    var handleFieldValueChange = function (value, field) {
        var results = formFields.map(function (eachField) {
            if (eachField === field) {
                if (eachField.type === "checkbox") {
                    if (!eachField.valueArr)
                        eachField.valueArr = [];
                    if (!value && eachField.valueArr.length == 1)
                        eachField.valueArr.splice(0, 1);
                    else
                        eachField.valueArr.push(value);
                    eachField.value = eachField.valueArr;
                }
                else if (eachField.type === "multicheckbox"
                // ||
                // eachField.type === "checkbox"
                ) {
                    if (!eachField.valueArr)
                        eachField.valueArr = [];
                    if (eachField.valueArr.includes(value)) {
                        var index = eachField.valueArr.indexOf(value);
                        if (index > -1) {
                            eachField.valueArr.splice(index, 1);
                        }
                    }
                    else
                        eachField.valueArr.push(value);
                    eachField.value = eachField.valueArr;
                }
                else {
                    eachField.value = value;
                }
                if (eachField.error)
                    eachField = isValidField(eachField);
                // if (eachField.field_type == "SYSTEM" && field.name == "message")
                //   setTypeText(value);
            }
            return eachField;
        });
        setFormFields(results);
    };
    useEffect(function () {
        var storedFormData = {};
        try {
            var obj = getFormData();
            if (obj)
                storedFormData = JSON.parse(obj);
        }
        catch (error) { }
        var fields = [];
        execution.node.data.formData.mapped_fields.forEach(function (field, index) {
            var fieldClone = JSON.parse(JSON.stringify(field));
            fieldClone.value =
                storedFormData[fieldClone.name] &&
                    !(field.field_type == "SYSTEM" && field.name == "message")
                    ? storedFormData[fieldClone.name]
                    : "";
            if (fieldClone.type == "multicheckbox" || fieldClone.type == "checkbox")
                fieldClone.valueArr = storedFormData[fieldClone.name]
                    ? Array.from(storedFormData[fieldClone.name])
                    : [];
            fieldClone.is_valid = false;
            fields.push(fieldClone);
        });
        setFormFields(fields);
    }, []);
    var _c = useState(execution.node.data.formData.mapped_fields), formFields = _c[0], setFormFields = _c[1];
    var _d = useState(false), saving = _d[0], setSaving = _d[1];
    var isvalidForm = function () {
        var isValid = true;
        var results = formFields.map(function (field) {
            field = isValidField(field);
            if (isValid)
                isValid = field.is_valid;
            return field;
        });
        setFormFields(results);
        return isValid;
    };
    var getFormMetaData = function () {
        var meta = {};
        // Form data if any
        var formDataArray = getLocalStoragePrefs(FORM_DATA_ARRAY);
        meta.form_data = JSON.parse(formDataArray);
        return meta;
    };
    var submitForm = function () {
        if (isvalidForm()) {
            // Set field data in to storage
            setSaving(true);
            var obj_1 = {};
            var form_data_1 = [];
            formFields.map(function (field) {
                if (field.value)
                    obj_1[field.name] = field.value;
                form_data_1.push({
                    name: field.name,
                    value: field.value
                });
            });
            console.log("formdata", obj_1);
            setLocalStoragePrefs(FORM_DATA_ARRAY, JSON.stringify(form_data_1));
            var formData = getLocalStoragePrefs(FORM_DATA);
            if (formData) {
                formData = JSON.parse(formData);
                Object.assign(formData, obj_1);
            }
            else {
                formData = obj_1;
            }
            setLocalStoragePrefs(FORM_DATA, JSON.stringify(formData));
            sendMessage();
            // submitChatForm(obj);
        }
    };
    var sendMessage = function () {
        execution.nodeId = execution.node.id;
        execution.isExecuted = true;
        execution.responseAction = [
            {
                id: execution.node.id,
                type: "FORM_DATA",
                data: JSON.stringify(getFormMetaData()),
            },
        ];
        executeNodeOnUserInteraction(execution);
    };
    var getData = function () {
        try {
            return JSON.parse(execution.responseAction[0].data).form_data.map(function (data, index) {
                var field = formFields.find(function (field) { return field.name == data.name; });
                return _jsxs("div", __assign({ style: { lineHeight: "1.5" } }, { children: [" ", _jsx("span", __assign({ style: { fontWeight: "500" } }, { children: (field === null || field === void 0 ? void 0 : field.field_label) || (field === null || field === void 0 ? void 0 : field.label) })), ": ", data.value] }));
            });
        }
        catch (error) {
            return undefined;
        }
    };
    return (_jsx(_Fragment, { children: !execution.isExecuted ? (_jsx("div", __assign({ className: "chat__messages-group" }, { children: _jsx("ul", __assign({ className: "chat__messages-list multi_choice-list", style: { display: "block", width: "85%" } }, { children: _jsx("div", __assign({ className: "chat_agent_data", style: { display: "flex" } }, { children: _jsx(FormComponent, { message: (_b = execution.node.data.formData) === null || _b === void 0 ? void 0 : _b.message, formFields: formFields, handleFieldValueChange: handleFieldValueChange, saving: saving, submitForm: submitForm }) })) })) }))) : (_jsx("div", __assign({ className: "chat__messages-group chat__messages-group--me" }, { children: _jsx("ul", __assign({ className: "chat__messages-list" }, { children: _jsx("div", __assign({ className: "chat__messages-list-item" }, { children: _jsx("div", __assign({ className: "chat__messages-bubble chat__message-type-TEXT" }, { children: _jsxs("span", __assign({ className: "actual" }, { children: [_jsx("span", __assign({ style: { fontWeight: "500", fontSize: "15px", paddingBottom: "2px", display: "inline-block" } }, { children: "Form Data" })), getData()] })) })) })) })) }))) }));
};
export default CollectFormData;
